import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import CaseloadRiskChartWidget from "../Presentational/Widgets/CaseloadRiskChartWidget";
import CaseloadService from "../../Services/Caseload.service";
import useService from "../Hooks/useService";
const CaseloadRiskChart = (props) => {
    const [dataState, loadData] = useService(React.useMemo(() => props.courseRisk
        ? CaseloadService.getCourseRiskSummary
        : CaseloadService.getPersistenceRiskSummary, [props.courseRisk]));
    React.useEffect(() => {
        loadData();
    }, [loadData]);
    return (_jsx(CaseloadRiskChartWidget, { refresh: () => {
            loadData();
        }, courseRisk: props.courseRisk, data: dataState }));
};
export default CaseloadRiskChart;
